import React from 'react'
import { BaseModalProps } from '@/components/modals/base-modal/base-modal'
import {
  Button,
  DialogContent,
  DialogContentText,
  TextField,
} from '@mui/material'
import { t } from 'i18next'
import api from '@/api'
import { download } from '@/utils'
import FormModal from '@/components/modals/FormModal'
import LoadingButton from '@mui/lab/LoadingButton'

interface Props extends BaseModalProps {}

const DealInvoicesExportModal: React.FC<Props> = ({ isOpen, onClose }) => {
  const [isLoading, setIsLoading] = React.useState(false)

  const onSubmit = async (data: any) => {
    setIsLoading(true)
    const dealId = data.deal_id
    const res = await api.get<any>(
      'exports/deal-invoices/',
      { deal_id: dealId },
      {},
      { responseType: 'arraybuffer' },
    )
    download(res.data, `Deal ${dealId} Invoices.xlsx`)
    setIsLoading(false)
    onClose()
  }

  return (
    <FormModal
      onSubmit={onSubmit}
      isOpen={isOpen}
      onClose={onClose}
      actions={
        <>
          <Button onClick={onClose}>{`${t('cancel')}`}</Button>
          <LoadingButton loading={isLoading} type="submit">{`${t(
            'export',
          )}`}</LoadingButton>
        </>
      }
    >
      <DialogContentText>
        הכנס מזהה עסקה על מנת לייצא נתוני חשבוניות
      </DialogContentText>
      <TextField
        autoFocus
        required
        margin="dense"
        id="deal_id"
        name="deal_id"
        label={`${t('deal_id')}`}
        fullWidth
        variant="standard"
      />
    </FormModal>
  )
}

export default DealInvoicesExportModal
